import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Card, Image } from 'semantic-ui-react'

class SimpleCard extends Component {
    render() {
        const showContent = 
        this.props.title !== undefined ||
        this.props.subtitle !== undefined ||
        this.props.text !== undefined;
        return (
            <Card style={Style.card}>
                <Image src={this.props.image} circular bordered/>
                { showContent && <Card.Content>
                { this.props.title &&
                    <Card.Header style={Style.title}>{this.props.subtitle}</Card.Header>}
                    {/* <Card.Meta>
                        <span className='date'>{this.props.subtitle}</span>
                    </Card.Meta> */}
                    <Card.Description style={this.props.style}>{this.props.text}</Card.Description>
                </Card.Content>}
            </Card>
        );
    }
}
SimpleCard.PropTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    text: PropTypes.string,
    imagePath: PropTypes.string,
};
  
SimpleCard.defaultProps = {
    //title: "Title",
    //text: "This is the description, some text",
    //subtitle: 'Subtitle',
    //imagePath:config.website.header.icon,
};
const Style = {
    card: {
      //height:'auto',
      top:'-15px',
      width: '100%',
      //height:'100%',
      background: 'lightgray',// config.website.header.background,//"#40bf40"
    },
    title: {
      height: '35px',
      color: 'gray',//'#e1e1a2',
      fontFamily: "'Palatino Linotype', 'Book Antiqua', Palatino, serif",
      fontSize: '18px',
      fontWeight: '900',
      margin: '-15px -15px 0px -15px',
      background: 'lightgray',// config.website.header.background,//"#40bf40"
    },
  }
export default SimpleCard


// WEBPACK FOOTER //
// ./src/components/SimpleCard.js